module.exports = __webpack_public_path__ + "static/img/img-xj.6d4c404.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-xj.png
// module id = UvZR
// module chunks = 1